module.exports = __webpack_public_path__ + "static/media/S1N2.ab5ab8eb.svg";